import React from 'react'

function Footer() {
    return (
        <div className='footer2'>
            <div className="container">
                <div className="d-flex align-items-center justify-content-center flex-column position-relative text-center">
                    <div className="testimonial-hr d-flex align-items-center gap-2">
                        <hr />
                        <h6>NewsLetter</h6>
                    </div>
                    <h3>JOIN OUR MAILING LIST</h3>
                    <p>Stay updated with exclusive offers, promotions, and important news by subscribing to our email list for regular updates.</p>
                </div>
                <form action="" id='footer-form' className='d-flex justify-content-between flex-md-row flex-sm-column flex-column gap-md-0 gap-sm-4 gap-4 gap-4'>
                    <input type="email" placeholder='Enter Your Email' required />
                    <button className='btn_1'>Get Started</button>
                </form>
            </div>
        </div>
    )
}

export default Footer
